import * as OfficeHelpers from "../../officeHelpers";
import * as Api from "../../api";
import { useCallback, useEffect, useRef, useState } from "react";
import { useError } from "./useError";
import { MessageBarType } from "@fluentui/react";

async function insertMeetingLinkHtml(meeting) {
  try {
    const bodyType = await OfficeHelpers.getItemBodyType();
    if (bodyType == Office.CoercionType.Html) {
      const body = await OfficeHelpers.getItemBody(Office.CoercionType.Html);
      let newBody;
      if (body.includes("</body>")) {
        newBody = body.replace(/<\/body>/i,
          `<p>______________________________________________________________________</p><p style="margin: 0px"><b>XMReality Remote Guidance</b></p><p style="margin: 0px">Participants use this link to join</p><p style="margin: 0px"><a href="${meeting.url}">${meeting.url}</a></p><p>______________________________________________________________________</p></body>`);
      } else {
        newBody = body +
          `<p>______________________________________________________________________</p><p style="margin: 0px"><b>XMReality Remote Guidance</b></p><p style="margin: 0px">Participants use this link to join</p><p style="margin: 0px"><a href="${meeting.url}">${meeting.url}</a></p><p>______________________________________________________________________</p>`;
      }
      await OfficeHelpers.setItemBody(newBody, {
        coercionType: Office.CoercionType.Html,
      });
    } else {
      const body = await OfficeHelpers.getItemBody(Office.CoercionType.Text);
      const newBody = body +
       `\n\n-----------------------------------------------------------------------------\n\nXMReality Remote Guidance\nParticipants use this link to join\n${meeting.url}\n\n-----------------------------------------------------------------------------\n`;
      await OfficeHelpers.setItemBody(newBody, {
        coercionType: Office.CoercionType.Text,
      });
    }
  } catch (e) {

  }
}

async function removeMeetingLink() {
  const bodyType = await OfficeHelpers.getItemBodyType();
    if (bodyType == Office.CoercionType.Html) {
      const body = await OfficeHelpers.getItemBody(Office.CoercionType.Html);
      const regex = new RegExp(
        `<p>[^_]*_+[^_]+XMReality[^_]+_+[^_]*</p>`
      );
      const newBody = body.replace(regex, "");
      await OfficeHelpers.setItemBody(newBody, {
        coercionType: Office.CoercionType.Html,
      });
    } else {
      const body = await OfficeHelpers.getItemBody(Office.CoercionType.Text);
      const regex = new RegExp(
        `-+[^-]*XMReality[^-]*-+`
      );
      const newBody = body.replace(regex, "");
      await OfficeHelpers.setItemBody(newBody, {
        coercionType: Office.CoercionType.Text,
      });
    }
}

export function useMeeting(setMessage) {
  const [loading, setLoading] = useState(false);
  const [meeting, setMeeting] = useState(null);
  const itemPropsRef = useRef(null);

  useEffect(async () => {
    setLoading(true);
    try {
      itemPropsRef.current = await OfficeHelpers.loadItemProps();
      const meetingId = itemPropsRef.current.get("meetingId");
      if (meetingId) {
        const meeting = await Api.getMeeting(meetingId);
        setMeeting(meeting);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    };
  }, []);

  const onAddMeetingLink = useCallback(async () => {
    try {
      const title = await OfficeHelpers.getItemSubject();
      if (!title?.trim()) {
        setMessage({ text: "Set title before adding an XMReality link.", type: MessageBarType.info });
        return;
      }
      setLoading(true);
      const scheduledAt = await OfficeHelpers.getItemStart();
      const meeting = await Api.createMeeting(title, scheduledAt);
      itemPropsRef.current.set("meetingId", meeting.id);
      setMeeting(meeting);
      insertMeetingLinkHtml(meeting);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  });

  const onRemoveMeetingLink = useCallback(async () => {
    try {
      const { id } = meeting;
      await Api.deleteMeeting(id);
      itemPropsRef.current.remove("meetingId");
      setMeeting(null);
      removeMeetingLink();
    } catch (e) {
      OfficeHelpers.setInfoMessage(e.message);
    }
  }, [meeting]);

  return [loading, meeting, onAddMeetingLink, onRemoveMeetingLink];
}
